// extracted by mini-css-extract-plugin
export default {"player":"IFrameWrapper_player__DyCRf","lefticon":"IFrameWrapper_lefticon__Y6N9t","example":"IFrameWrapper_example__9-oY+"};